import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getVideoPagesTemplates } from 'services/videoPages.service';
import VideoCard from '../components/VideoCard';

const Templates = ({}) => {
  const [templates, setTemplates] = useState();
  useEffect(() => {
    getVideoPagesTemplates().then(setTemplates);
  }, []);

  return (
    <Box>
      <Helmet title="Templates" />
      <Grid container spacing={2}>
        {templates?.map((item) => (
          <Grid item xs={12} md={4} lg={3}>
            <VideoCard item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Templates;
